//@flow
import Enum from 'common/enums/Enum';

export const DayOfWeekType = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};

export const DayOfWeekKeysType = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday'
};

export const DaysOfWeek = [
    DayOfWeekKeysType.Sunday,
    DayOfWeekKeysType.Monday,
    DayOfWeekKeysType.Tuesday,
    DayOfWeekKeysType.Wednesday,
    DayOfWeekKeysType.Thursday,
    DayOfWeekKeysType.Friday,
    DayOfWeekKeysType.Saturday
];

export const DayOfWeekTypeAlias = new Enum({
    MONDAY: 'Mon',
    TUESDAY: 'Tue',
    WEDNESDAY: 'Wed',
    THURSDAY: 'Thu',
    FRIDAY: 'Fri',
    SATURDAY: 'Sat',
    SUNDAY: 'Sun'
});

export const DaysOrderEnum = new Enum({
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
});

export const WeeksOrderEnum = new Enum({
    WEEK1: 0,
    WEEK2: 1,
    WEEK3: 2,
    WEEK4: 3,
    WEEK5: 4
});

export type Day =
    | 'monday'
    | 'tuesday'
    | 'wednesday'
    | 'thursday'
    | 'friday'
    | 'saturday'
    | 'sunday';

export const DateGroupEnum = new Enum({
    Today: 'TODAY',
    Tomorrow: 'TOMORROW',
    Custom: 'CUSTOM'
});
